



























































































































interface NavList {
    name: string;
    dataList: string;
}
import { Component, Vue, Watch } from "vue-property-decorator";
import SideNavVue from "../components/SideNav.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import InventoryBalanceSheetVue from "../components/Balance/InventoryBalanceSheet.vue";
import AssistingSubsidiaryLedgerVue from "./AssistingSubsidiaryLedger.vue";
import version from "@/version";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "side-nav": SideNavVue,
        "month-selector": MonthSelectorVue,
        "inventory-balanceSheet": InventoryBalanceSheetVue,
        "assisting-subsidiaryLedger": AssistingSubsidiaryLedgerVue
    }
})
export default class AssistingBalance extends Vue {
    currentAccountTypeName: string = "项目"; //辅助明细账的类别名
    isRetract: boolean = true;
    tableData: Balance.Balance[] = [];
    amount: boolean = false; // 展示数量金额

    //改变时间
    period: String[] = []; // 日期
    dailogDate: Date[] = [];//弹窗日期
    changeDate(date: string[]) {
        this.period = date;
        let date1 = new Date(this.period[0].substring(0, 4) + "-" + this.period[0].substring(4));
        let date2 = new Date(this.period[1].substring(0, 4) + "-" + this.period[1].substring(4));
        this.dailogDate = [date1, date2];
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(`dim/balance/getlist`, {
                accountBookId: this.$store.state.accountBook.id,
                dimAccountType: this.currentAccountTypeName,
                endPeriod: this.period[1],
                startPeriod: this.period[0]
            })
            .then(res => {
                this.tableData = res.data.data;
                if (res.data.isNum === 1) {
                    this.amount = true;
                } else {
                    this.amount = false;
                }
            });
    }

    // 监听侧边栏切换
    @Watch("currentAccountTypeName")
    changeName() {
        this.fetchData();
        let elements: any = document.querySelectorAll(".hidden-row[data-num]");
        let iconInTds: any = document.querySelectorAll(
            "#AssistingBalance .assist-balance-row td i"
        );
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "";
        }
        for (let i = 0; i < iconInTds.length; i++) {
            iconInTds[i].setAttribute("class", "el-icon-caret-bottom");
        }
        this.isRetract = true;
    }

    // 数量金额余额表
    showInventory: boolean = false;
    showAmount() {
        this.showInventory = true;
    }

    // 打开辅助核算明细账
    dimRelation: Assist.Relation | {} = {};
    showAssistSub: boolean = false;
    dimItemId: number | null = null;
    subjectId: number | null = null;
    longText: string = "";
    assistSub(data: Balance.Balance) {
        this.subjectId = data.subjectId;
        if (data.relation) {
            this.dimItemId = data.relation.dimItemId;
            this.dimRelation = data.relation
        }
        this.longText = data.no + " " + data.text;
        this.showAssistSub = true;
    }

    //点击每一行
    addColor(event: any) {
        let dataTbody: any = document.querySelectorAll("#data-tbody tr");
        for (let i = 0; i < dataTbody.length; i++) {
            if (dataTbody[i].classList.contains("active-content"))
                dataTbody[i].classList.remove("active-content");
        }
        event.currentTarget.classList.add("active-content");
    }
    //点击switchButton
    showSubject(val: boolean) {
        let elements: any = document.querySelectorAll(".hidden-row[data-num]");
        let iconInTds: any = document.querySelectorAll(
            "#AssistingBalance .assist-balance-row td i"
        );
        if (val) {
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.display = "";
            }
            for (let i = 0; i < iconInTds.length; i++) {
                iconInTds[i].setAttribute("class", "el-icon-caret-bottom");
            }
            this.isRetract = true;
        } else {
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.display = "none";
            }
            for (var i = 0; i < iconInTds.length; i++) {
                iconInTds[i].setAttribute("class", "el-icon-caret-right");
            }
            this.isRetract = false;
        }
    }
    //隐藏行
    hideTheRow(pno: any, el: any) {
        let eles: any = document.querySelectorAll(".hidden-row[data-num]");
        let iconInTds: any = document.querySelectorAll(
            "#AssistingBalance .assist-balance-row td i"
        );
        if (el.currentTarget.getAttribute("class") == "el-icon-caret-bottom") {
            el.currentTarget.setAttribute("class", "el-icon-caret-right");
            for (let i = 0; i < eles.length; i++) {
                if (eles[i].getAttribute("data-num") == pno) {
                    eles[i].style.display = "none";
                }
            }
        } else {
            el.currentTarget.setAttribute("class", "el-icon-caret-bottom");
            for (let i = 0; i < eles.length; i++) {
                if (eles[i].getAttribute("data-num") == pno) {
                    eles[i].style.display = "";
                }
            }
        }
        if (
            document.querySelectorAll(
                "#AssistingBalance .assist-balance-row i.el-icon-caret-right"
            ).length > 0
        ) {
            this.isRetract = false;
        } else {
            this.isRetract = true;
        }
    }
    // 下载
    downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/balance/dim?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&showSub=${this.isRetract}&version=${version}&dimAccountType=${this.currentAccountTypeName}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
}
